import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { rem } from '@utils';

interface TitleSectionProps {
    name: string;
    small?: boolean;
}

const TitleSectionShopping: React.FC<TitleSectionProps> = ({
    name, small,
}: TitleSectionProps) => {
    const { typography } = useTheme();
    return (
        <Box>
            <Typography
                sx={{
                    fontWeight: typography.fontWeightBold,
                    fontSize: !small ? rem(16) : rem(14),
                }}
                variant='h3'>
                {name}
            </Typography>
        </Box>
    );
};

export { TitleSectionShopping };
